import http from '../http';

const work = {
    /**
     * 获取菜单
     * @param {} filters
     */
    getMenuInfoList(filters) {
        return http.get(`/auth_resource/menuinfo/queryMenuInfoList`, {params: filters});
    },
    /**
     * 获取一级菜单
     */
    getFirstLevelMenuList() {
        return http.get(`/auth_resource/menuinfo/getFirstLevelMenuList`,);
    },
    /**
     * 添加菜单
     */
    addMenuList(model) {
        return http.post(`/auth_resource/menuinfo/addMenuInfoList`, model);
    },
    /**
     * 编辑菜单
     */
    updateMenuInfoList(model) {
        return http.post(`/auth_resource/menuinfo/updateMenuInfoList`, model);
    },
    /**
     * 根据id查询详情
     * @param {*} model
     */
    getMenuInfoById(filters) {
        return http.get(`/auth_resource/menuinfo/getMenuInfoById`, {params: filters});
    },

    /**
     * 删除菜单
     */
    deleteMenu(model) {
        return http.post(`/auth_resource/menuinfo/delMenuInfo`, model);
    },
    /**
     * 修改菜单状态
     */
    setMenuStatus(model) {
        return http.post(`/auth_resource/menuinfo/setMenuStatus`, model);
    },


    /**
     * 用户列表分页查询接口
     * @param {*} model
     */
    getUserList(filters) {
        return http.get(`/auth_resource/userInfo/queryUserInfoList`, {params: filters});
    },

    /**
     * 根据主键Id获取用户信息-编辑页回显
     * @param {*} model
     */
    getUserById(filters) {
        return http.get(`/auth_resource/userInfo/getUserInfoById`, {params: filters});
    },

    /**
     * 修改用户信息
     * @param {*} model
     */
    updateUser(model) {
        return http.post(`/auth_resource/userInfo/updateUserInfo`, model);
    },

    /**
     * GET 获取所有角色信息列表，下拉框数据源
     * @param {*} model
     */
    getAllUserList(filters) {
        return http.get(`/auth_resource/userRoleInfo/getUserRoleInfo`, {params: filters});
    },

    /**
     * POST 删除用户信息
     * @param {*} model
     */
    deleteUser(model) {
        return http.post(`/auth_resource/userInfo/deleteUserInfoListById`, model);
    },

    /**
     * GET 编辑用户状态
     * @param {*} model
     */
    updateUserStatus(filters) {
        return http.get(`/auth_resource/userInfo/updateUserStatusById`, {params: filters});
    },
    /**
     * 获取标签管理列表
     * @param params
     * @returns {Promise<AxiosResponse<any>>}
     */
    getTagsList(params) {
        return http.get("/work_order/label/list", {params})
    },
    /**
     * 更新标签信息
     * @param data
     * @returns {Promise<AxiosResponse<any>>}
     */
    updateTags(data) {
        return http.post("/work_order/label/edit", data)
    },
    /**
     * 删除标签
     * @param params
     * @returns {Promise<AxiosResponse<any>>}
     */
    deleteTags(params) {
        return http.delete(`/work_order/label/delete/${params.id}`)
    },
    /**
     * 添加标签
     * @param data
     * @returns {Promise<AxiosResponse<any>>}
     */
    addTags(data) {
        return http.post("/work_order/label/create", data)
    },
    /**
     * 获取标签详情
     * @param params
     * @returns {Promise<AxiosResponse<any>>}
     */
    getTags(params) {
        return http.get("/work_order/label/info", {params})
    },
    /**
     * 获取可用的标签列表
     * @returns {Promise<AxiosResponse<any>>}
     */
    getAllTag() {
        return http.get("/work_order/label/enableLabelGroup")
    },
    /**
     * 根据工单问题类型id获取标签组
     * @param params
     * @returns {Promise<AxiosResponse<any>>}
     */
    getTagsByQaTypeId(params) {
        return http.get("/work_order/label/infoByQaType", {params})
    },
    /**
     * 打标记
     * @param params
     * @returns {Promise<AxiosResponse<any>>}
     */
    markTag(params) {
        return http.post("/work_order/label/marking", params)
    },
    /**
     * 获取标签树状数据
     * @returns {Promise<AxiosResponse<any>>}
     */
    getTagTree() {
        return http.get("/work_order/label/tree")
    },
    /**
     * 同步用户信息
     * @returns {Promise<AxiosResponse<any>>}
     */
    syncUserInfo() {
        return http.post("/work_order/userInfo/syncUser")
    }
}
export default work;
